import { useEffect } from 'react';

export default function useSOCRadar() {
  useEffect(() => {
    const hostname = window.location.hostname;
    const isStageDomain =
      hostname === 'website.stage.greenlight.gl-tech.io' ||
      hostname.endsWith('.website.stage.greenlight.gl-tech.io');
    const isGreenlightDomain =
      hostname === 'greenlight.com' || hostname.endsWith('.greenlight.com');

    let beaconPath: string | null = null;

    if (!isStageDomain && !isGreenlightDomain) {
      const bodyEnv = document.body?.getAttribute('data-env');
      if (bodyEnv === 'staging') {
        beaconPath = '//cdntx.net/cdn/o1paalk6plbb5nbz0zgd8ep9x/app.css?l=';
      } else if (bodyEnv === 'production') {
        beaconPath = '//cdntx.net/cdn/mpsffjj0mzpyceyhnlig7m2i1/bg.img?l=';
      }
    }

    if (beaconPath) {
      const protocol = document.location.protocol.startsWith('http')
        ? document.location.protocol
        : 'http:';
      const l = location.href;
      const r = document.referrer;
      const img = new Image();
      img.src = protocol + beaconPath + encodeURI(l) + '&r=' + encodeURI(r);
    }
  }, []);
}
